import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const securityFeatures = [
    {
      icon: "Shield",
      title: "SSL Encrypted",
      description: "256-bit SSL encryption"
    },
    {
      icon: "Lock",
      title: "SOC 2 Compliant",
      description: "Enterprise security standards"
    },
    {
      icon: "CheckCircle",
      title: "GDPR Ready",
      description: "Privacy regulation compliant"
    },
    {
      icon: "Award",
      title: "99.9% Uptime",
      description: "Reliable service guarantee"
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Marketing Director",
      company: "TechFlow Inc.",
      content: "PitchEngine AI has transformed our content creation process. The prompt suggestions are incredibly accurate and save us hours of brainstorming.",
      rating: 5,
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face"
    },
    {
      id: 2,
      name: "Michael Rodriguez",
      role: "Legal Counsel",
      company: "LawTech Solutions",
      content: "The categorized prompts feature is a game-changer for our legal documentation. Highly recommend the Scale-Up plan for professional teams.",
      rating: 5,
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face"
    },
    {
      id: 3,
      name: "Emily Watson",
      role: "Creative Director",
      company: "Brand Studio",
      content: "The custom GPT system in the Command tier has revolutionized our creative workflows. Worth every penny for enterprise-level needs.",
      rating: 5,
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face"
    }
  ];

  return (
    <div className="space-y-16">
      {/* Security Badges */}
      <div className="text-center">
        <h3 className="text-2xl font-bold text-text-primary mb-8">
          Trusted by 10,000+ Professionals
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="text-center space-y-3">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                <Icon 
                  name={feature?.icon} 
                  size={24} 
                  color="var(--color-primary)" 
                />
              </div>
              <div>
                <h4 className="font-semibold text-text-primary text-sm">
                  {feature?.title}
                </h4>
                <p className="text-text-secondary text-xs">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Customer Testimonials */}
      <div className="text-center">
        <h3 className="text-2xl font-bold text-text-primary mb-8">
          What Our Customers Say
        </h3>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials?.map((testimonial) => (
            <div key={testimonial?.id} className="bg-card rounded-xl p-6 border border-border shadow-soft">
              <div className="flex items-center space-x-1 mb-4 justify-center">
                {[...Array(testimonial?.rating)]?.map((_, i) => (
                  <Icon 
                    key={i} 
                    name="Star" 
                    size={16} 
                    color="var(--color-warning)" 
                    className="fill-current"
                  />
                ))}
              </div>
              <p className="text-text-secondary text-sm mb-6 leading-relaxed">
                "{testimonial?.content}"
              </p>
              <div className="flex items-center space-x-3 justify-center">
                <div className="w-10 h-10 rounded-full overflow-hidden">
                  <img 
                    src={testimonial?.avatar} 
                    alt={testimonial?.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-left">
                  <h4 className="font-semibold text-text-primary text-sm">
                    {testimonial?.name}
                  </h4>
                  <p className="text-text-secondary text-xs">
                    {testimonial?.role}, {testimonial?.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;